import { useCallback, useRef, useState } from "react";
import { LngLat, MapMouseEvent } from "react-map-gl/maplibre";

interface Options {
  delayMs?: number;
}

export function useDelayedHoverLocation(options?: Options) {
  const delayMs = options?.delayMs ?? 500;
  const [currentLocation, setCurrentLocation] = useState<LngLat | null>(null);
  const hoverTimeoutRef = useRef<number | null>(null);

  const onHover = useCallback(
    (event: MapMouseEvent) => {
      if (hoverTimeoutRef.current !== null) {
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = null;
      }
      hoverTimeoutRef.current = window.setTimeout(() => {
        setCurrentLocation(event.lngLat);
      }, delayMs);
    },
    [delayMs]
  );

  const onMouseOut = useCallback(() => {
    if (hoverTimeoutRef.current !== null) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setCurrentLocation(null);
  }, []);

  return {
    onHover,
    onMouseOut,
    currentLocation,
  };
}
